export default "__VITE_ASSET__wgAAx4eJ__"